import { render, staticRenderFns } from "./ReportNNGP.vue?vue&type=template&id=264126f2&scoped=true"
import script from "./ReportNNGP.vue?vue&type=script&lang=js"
export * from "./ReportNNGP.vue?vue&type=script&lang=js"
import style0 from "./ReportNNGP.vue?vue&type=style&index=0&id=264126f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264126f2",
  null
  
)

export default component.exports